export default "__VITE_ASSET__C7QC3LIG__"